/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.19.0
 */

import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import {
    tableContext,
    tableMetaButtonsEnabledSelector,
    tableMetaButtonsSelector,
    tableMetaColumnsSelector,
    tableMetaUrlSelector,
} from '../selectors';
import { TTableColumnConfig } from '../types';

export const useTableMetaApi = <D extends object>(
    columnsConfig: TTableColumnConfig<D>,
    cellSizeConfig?: Record<string, number>,
) => {
    const metaUrl = useSelector(tableMetaUrlSelector);
    const context = useSelector(tableContext);

    const columnsSelector = useMemo(
        () => tableMetaColumnsSelector(columnsConfig, metaUrl, context, cellSizeConfig),
        [cellSizeConfig, columnsConfig, context, metaUrl],
    );
    const columns = useSelector(columnsSelector);

    const buttonsEnabledSelector = useMemo(() => tableMetaButtonsEnabledSelector(metaUrl), [metaUrl]);
    const buttonsEnabled = useSelector(buttonsEnabledSelector);

    const buttonsSelector = useMemo(() => tableMetaButtonsSelector(metaUrl), [metaUrl]);
    const buttons = useSelector(buttonsSelector);

    return {
        buttons,
        buttonsEnabled,
        columns,
    };
};
